import { Component, ElementRef, AfterViewInit, ViewChild, Input } from '@angular/core';
import { OpenTokService } from '../services/open-tok.service';

const publish = () => {

};

@Component({
  selector: 'app-publisher',
  templateUrl: './publisher.component.html',
  styleUrls: ['./publisher.component.scss']
})

export class PublisherComponent implements AfterViewInit {
  @ViewChild('publisherDiv') publisherDiv: ElementRef;
  @Input() session: OT.Session;
  publisher: OT.Publisher;

  constructor(private opentokService: OpenTokService) { }

  ngAfterViewInit() {
    const OT = this.opentokService.getOT();
    this.publisher = OT.initPublisher(this.publisherDiv.nativeElement);

    console.log(this.session);
    if (this.session) {
      console.log(this.session['isConnected']());
      if (this.session['isConnected']()) {
        console.log('connected');
        alert('connected');
        this.publish();
      }
      this.session.on('sessionConnected', () => this.publish());
    }
  }

  publish() {
    this.session.publish(this.publisher, (err) => {
      if (err) {
        alert(err.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/publisher/publisher.component.ts